export const getLocalStorage = (key: string) => {
  if (typeof window === 'undefined') {
    return null;
  }

  const value = localStorage.getItem(key);
  if (value !== null) {
    try {
      return JSON.parse(value);
    } catch (error) {
      // Not a JSON object.
      return value;
    }
  }

  return null;
};

export const setLocalStorage = (key: string, value: any, json = true) => {
  if (typeof window === 'undefined') {
    return null;
  }

  let stringValue = value;
  if (value && json) {
    stringValue = JSON.stringify(value);
  }

  localStorage.setItem(key, stringValue);
};
